export default "__VITE_ASSET__nog75S0B__"